__turbopack_context__.v({
  "link": "IconCategoryBrowse-module-scss-module__9Ytn-G__link",
  "root": "IconCategoryBrowse-module-scss-module__9Ytn-G__root",
});
